/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarPacienteDto,
  CriarPacienteDto,
  ErroResponse,
  ListaDePesosResponse,
  PacienteResponse,
  PacientesControllerEnviarFotoBody,
  PacientesControllerListarParams,
  PaginaDePacientesResponse,
  PesoDoPacienteResponse,
  RegistrarPesoDto,
  VincularTagsDePacienteDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPacientesControllerListarUrl = (params?: PacientesControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/pacientes?${stringifiedParams}` : `/v1/pacientes`
}

/**
 * @summary Lista os pacientes do ambiente. A busca cobre nome, microchip e nome do tutor.
 */
export const pacientesControllerListar = async (params?: PacientesControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDePacientesResponse> => {

  return httpClient<PaginaDePacientesResponse>(getPacientesControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPacientesControllerListarQueryKey = (params?: PacientesControllerListarParams,) => {
    return [
    `/v1/pacientes`, ...(params ? [params] : [])
    ] as const;
    }


export const getPacientesControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof pacientesControllerListar>>, TError = ErroResponse>(params?: PacientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPacientesControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pacientesControllerListar>>> = ({ signal }) => pacientesControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PacientesControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof pacientesControllerListar>>>
export type PacientesControllerListarQueryError = ErroResponse


export function usePacientesControllerListar<TData = Awaited<ReturnType<typeof pacientesControllerListar>>, TError = ErroResponse>(
 params: undefined |  PacientesControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pacientesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof pacientesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePacientesControllerListar<TData = Awaited<ReturnType<typeof pacientesControllerListar>>, TError = ErroResponse>(
 params?: PacientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pacientesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof pacientesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePacientesControllerListar<TData = Awaited<ReturnType<typeof pacientesControllerListar>>, TError = ErroResponse>(
 params?: PacientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os pacientes do ambiente. A busca cobre nome, microchip e nome do tutor.
 */

export function usePacientesControllerListar<TData = Awaited<ReturnType<typeof pacientesControllerListar>>, TError = ErroResponse>(
 params?: PacientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPacientesControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPacientesControllerCriarUrl = () => {




  return `/v1/pacientes`
}

/**
 * @summary Cadastra um paciente. Sem `veterinarioId`, o responsável é quem está criando.
 */
export const pacientesControllerCriar = async (criarPacienteDto: CriarPacienteDto, options?: Parameters<typeof httpClient>[1]): Promise<PacienteResponse> => {

  return httpClient<PacienteResponse>(getPacientesControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarPacienteDto)
  }
);}





export const getPacientesControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerCriar>>, TError,{data: CriarPacienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerCriar>>, TError,{data: CriarPacienteDto}, TContext> => {

const mutationKey = ['pacientesControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pacientesControllerCriar>>, {data: CriarPacienteDto}> = (props) => {
          const {data} = props ?? {};

          return  pacientesControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PacientesControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof pacientesControllerCriar>>>
    export type PacientesControllerCriarMutationBody = CriarPacienteDto
    export type PacientesControllerCriarMutationError = ErroResponse

    /**
 * @summary Cadastra um paciente. Sem `veterinarioId`, o responsável é quem está criando.
 */
export const usePacientesControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerCriar>>, TError,{data: CriarPacienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pacientesControllerCriar>>,
        TError,
        {data: CriarPacienteDto},
        TContext
      > => {
      return useMutation(getPacientesControllerCriarMutationOptions(options), queryClient);
    }
    export const getPacientesControllerObterUrl = (id: string,) => {




  return `/v1/pacientes/${id}`
}

/**
 * @summary Detalha um paciente
 */
export const pacientesControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<PacienteResponse> => {

  return httpClient<PacienteResponse>(getPacientesControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPacientesControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/pacientes/${id}`
    ] as const;
    }


export const getPacientesControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof pacientesControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPacientesControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pacientesControllerObter>>> = ({ signal }) => pacientesControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PacientesControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof pacientesControllerObter>>>
export type PacientesControllerObterQueryError = ErroResponse


export function usePacientesControllerObter<TData = Awaited<ReturnType<typeof pacientesControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pacientesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof pacientesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePacientesControllerObter<TData = Awaited<ReturnType<typeof pacientesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pacientesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof pacientesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePacientesControllerObter<TData = Awaited<ReturnType<typeof pacientesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um paciente
 */

export function usePacientesControllerObter<TData = Awaited<ReturnType<typeof pacientesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pacientesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPacientesControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPacientesControllerAtualizarUrl = (id: string,) => {




  return `/v1/pacientes/${id}`
}

/**
 * @summary Edita parcialmente. Campo omitido fica como está; `null` apaga o valor.
 */
export const pacientesControllerAtualizar = async (id: string,
    atualizarPacienteDto: AtualizarPacienteDto, options?: Parameters<typeof httpClient>[1]): Promise<PacienteResponse> => {

  return httpClient<PacienteResponse>(getPacientesControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarPacienteDto)
  }
);}





export const getPacientesControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerAtualizar>>, TError,{id: string;data: AtualizarPacienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerAtualizar>>, TError,{id: string;data: AtualizarPacienteDto}, TContext> => {

const mutationKey = ['pacientesControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pacientesControllerAtualizar>>, {id: string;data: AtualizarPacienteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  pacientesControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PacientesControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof pacientesControllerAtualizar>>>
    export type PacientesControllerAtualizarMutationBody = AtualizarPacienteDto
    export type PacientesControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita parcialmente. Campo omitido fica como está; `null` apaga o valor.
 */
export const usePacientesControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerAtualizar>>, TError,{id: string;data: AtualizarPacienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pacientesControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarPacienteDto},
        TContext
      > => {
      return useMutation(getPacientesControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getPacientesControllerExcluirUrl = (id: string,) => {




  return `/v1/pacientes/${id}`
}

/**
 * @summary Exclusão lógica. O histórico clínico do animal continua no banco.
 */
export const pacientesControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getPacientesControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPacientesControllerExcluirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['pacientesControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pacientesControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  pacientesControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PacientesControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof pacientesControllerExcluir>>>

    export type PacientesControllerExcluirMutationError = ErroResponse

    /**
 * @summary Exclusão lógica. O histórico clínico do animal continua no banco.
 */
export const usePacientesControllerExcluir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pacientesControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPacientesControllerExcluirMutationOptions(options), queryClient);
    }
    export const getPacientesControllerEnviarFotoUrl = (id: string,) => {




  return `/v1/pacientes/${id}/foto`
}

/**
 * @summary Envia a foto. Proporção livre — quem fotografa está na consulta.
 */
export const pacientesControllerEnviarFoto = async (id: string,
    pacientesControllerEnviarFotoBody: PacientesControllerEnviarFotoBody, options?: Parameters<typeof httpClient>[1]): Promise<PacienteResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, pacientesControllerEnviarFotoBody.arquivo);

  return httpClient<PacienteResponse>(getPacientesControllerEnviarFotoUrl(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getPacientesControllerEnviarFotoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerEnviarFoto>>, TError,{id: string;data: PacientesControllerEnviarFotoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerEnviarFoto>>, TError,{id: string;data: PacientesControllerEnviarFotoBody}, TContext> => {

const mutationKey = ['pacientesControllerEnviarFoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pacientesControllerEnviarFoto>>, {id: string;data: PacientesControllerEnviarFotoBody}> = (props) => {
          const {id,data} = props ?? {};

          return  pacientesControllerEnviarFoto(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PacientesControllerEnviarFotoMutationResult = NonNullable<Awaited<ReturnType<typeof pacientesControllerEnviarFoto>>>
    export type PacientesControllerEnviarFotoMutationBody = PacientesControllerEnviarFotoBody
    export type PacientesControllerEnviarFotoMutationError = ErroResponse

    /**
 * @summary Envia a foto. Proporção livre — quem fotografa está na consulta.
 */
export const usePacientesControllerEnviarFoto = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerEnviarFoto>>, TError,{id: string;data: PacientesControllerEnviarFotoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pacientesControllerEnviarFoto>>,
        TError,
        {id: string;data: PacientesControllerEnviarFotoBody},
        TContext
      > => {
      return useMutation(getPacientesControllerEnviarFotoMutationOptions(options), queryClient);
    }
    export const getPacientesControllerRemoverFotoUrl = (id: string,) => {




  return `/v1/pacientes/${id}/foto`
}

/**
 * @summary Remove a foto. Idempotente — paciente sem foto responde 200.
 */
export const pacientesControllerRemoverFoto = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<PacienteResponse> => {

  return httpClient<PacienteResponse>(getPacientesControllerRemoverFotoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPacientesControllerRemoverFotoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerRemoverFoto>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerRemoverFoto>>, TError,{id: string}, TContext> => {

const mutationKey = ['pacientesControllerRemoverFoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pacientesControllerRemoverFoto>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  pacientesControllerRemoverFoto(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PacientesControllerRemoverFotoMutationResult = NonNullable<Awaited<ReturnType<typeof pacientesControllerRemoverFoto>>>

    export type PacientesControllerRemoverFotoMutationError = ErroResponse

    /**
 * @summary Remove a foto. Idempotente — paciente sem foto responde 200.
 */
export const usePacientesControllerRemoverFoto = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerRemoverFoto>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pacientesControllerRemoverFoto>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPacientesControllerRemoverFotoMutationOptions(options), queryClient);
    }
    export const getPacientesControllerVincularTagsUrl = (id: string,) => {




  return `/v1/pacientes/${id}/tags`
}

/**
 * @summary Substitui o conjunto de tags do paciente.
 */
export const pacientesControllerVincularTags = async (id: string,
    vincularTagsDePacienteDto: VincularTagsDePacienteDto, options?: Parameters<typeof httpClient>[1]): Promise<PacienteResponse> => {

  return httpClient<PacienteResponse>(getPacientesControllerVincularTagsUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vincularTagsDePacienteDto)
  }
);}





export const getPacientesControllerVincularTagsMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerVincularTags>>, TError,{id: string;data: VincularTagsDePacienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerVincularTags>>, TError,{id: string;data: VincularTagsDePacienteDto}, TContext> => {

const mutationKey = ['pacientesControllerVincularTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pacientesControllerVincularTags>>, {id: string;data: VincularTagsDePacienteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  pacientesControllerVincularTags(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PacientesControllerVincularTagsMutationResult = NonNullable<Awaited<ReturnType<typeof pacientesControllerVincularTags>>>
    export type PacientesControllerVincularTagsMutationBody = VincularTagsDePacienteDto
    export type PacientesControllerVincularTagsMutationError = ErroResponse

    /**
 * @summary Substitui o conjunto de tags do paciente.
 */
export const usePacientesControllerVincularTags = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerVincularTags>>, TError,{id: string;data: VincularTagsDePacienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pacientesControllerVincularTags>>,
        TError,
        {id: string;data: VincularTagsDePacienteDto},
        TContext
      > => {
      return useMutation(getPacientesControllerVincularTagsMutationOptions(options), queryClient);
    }
    export const getPacientesControllerFavoritarUrl = (id: string,) => {




  return `/v1/pacientes/${id}/favorito`
}

/**
 * @summary Marca o paciente como favorito de quem chamou. Idempotente.
 */
export const pacientesControllerFavoritar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<PacienteResponse> => {

  return httpClient<PacienteResponse>(getPacientesControllerFavoritarUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getPacientesControllerFavoritarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerFavoritar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerFavoritar>>, TError,{id: string}, TContext> => {

const mutationKey = ['pacientesControllerFavoritar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pacientesControllerFavoritar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  pacientesControllerFavoritar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PacientesControllerFavoritarMutationResult = NonNullable<Awaited<ReturnType<typeof pacientesControllerFavoritar>>>

    export type PacientesControllerFavoritarMutationError = ErroResponse

    /**
 * @summary Marca o paciente como favorito de quem chamou. Idempotente.
 */
export const usePacientesControllerFavoritar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerFavoritar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pacientesControllerFavoritar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPacientesControllerFavoritarMutationOptions(options), queryClient);
    }
    export const getPacientesControllerDesfavoritarUrl = (id: string,) => {




  return `/v1/pacientes/${id}/favorito`
}

/**
 * @summary Desmarca o favorito de quem chamou. Idempotente.
 */
export const pacientesControllerDesfavoritar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<PacienteResponse> => {

  return httpClient<PacienteResponse>(getPacientesControllerDesfavoritarUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPacientesControllerDesfavoritarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerDesfavoritar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerDesfavoritar>>, TError,{id: string}, TContext> => {

const mutationKey = ['pacientesControllerDesfavoritar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pacientesControllerDesfavoritar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  pacientesControllerDesfavoritar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PacientesControllerDesfavoritarMutationResult = NonNullable<Awaited<ReturnType<typeof pacientesControllerDesfavoritar>>>

    export type PacientesControllerDesfavoritarMutationError = ErroResponse

    /**
 * @summary Desmarca o favorito de quem chamou. Idempotente.
 */
export const usePacientesControllerDesfavoritar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pacientesControllerDesfavoritar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pacientesControllerDesfavoritar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getPacientesControllerDesfavoritarMutationOptions(options), queryClient);
    }
    export const getPesosControllerListarUrl = (pacienteId: string,) => {




  return `/v1/pacientes/${pacienteId}/pesos`
}

/**
 * @summary A série de peso do paciente, do mais antigo para o mais novo — é o que alimenta o gráfico. Sem paginação: é série temporal curta.
 */
export const pesosControllerListar = async (pacienteId: string, options?: Parameters<typeof httpClient>[1]): Promise<ListaDePesosResponse> => {

  return httpClient<ListaDePesosResponse>(getPesosControllerListarUrl(pacienteId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPesosControllerListarQueryKey = (pacienteId: string,) => {
    return [
    `/v1/pacientes/${pacienteId}/pesos`
    ] as const;
    }


export const getPesosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof pesosControllerListar>>, TError = ErroResponse>(pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pesosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPesosControllerListarQueryKey(pacienteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pesosControllerListar>>> = ({ signal }) => pesosControllerListar(pacienteId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pacienteId !== null && pacienteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pesosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PesosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof pesosControllerListar>>>
export type PesosControllerListarQueryError = ErroResponse


export function usePesosControllerListar<TData = Awaited<ReturnType<typeof pesosControllerListar>>, TError = ErroResponse>(
 pacienteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof pesosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof pesosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof pesosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePesosControllerListar<TData = Awaited<ReturnType<typeof pesosControllerListar>>, TError = ErroResponse>(
 pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pesosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof pesosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof pesosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePesosControllerListar<TData = Awaited<ReturnType<typeof pesosControllerListar>>, TError = ErroResponse>(
 pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pesosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A série de peso do paciente, do mais antigo para o mais novo — é o que alimenta o gráfico. Sem paginação: é série temporal curta.
 */

export function usePesosControllerListar<TData = Awaited<ReturnType<typeof pesosControllerListar>>, TError = ErroResponse>(
 pacienteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pesosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPesosControllerListarQueryOptions(pacienteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPesosControllerRegistrarUrl = (pacienteId: string,) => {




  return `/v1/pacientes/${pacienteId}/pesos`
}

/**
 * @summary Registra uma aferição e sincroniza o `pesoKg` do cadastro na MESMA transação. O cache é o peso de MAIOR `aferidoEm`, não o que acabou de entrar: lançar uma pesagem antiga não rebaixa o peso atual. `aferidoEm` omitido = hoje.
 */
export const pesosControllerRegistrar = async (pacienteId: string,
    registrarPesoDto: RegistrarPesoDto, options?: Parameters<typeof httpClient>[1]): Promise<PesoDoPacienteResponse> => {

  return httpClient<PesoDoPacienteResponse>(getPesosControllerRegistrarUrl(pacienteId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registrarPesoDto)
  }
);}





export const getPesosControllerRegistrarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pesosControllerRegistrar>>, TError,{pacienteId: string;data: RegistrarPesoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pesosControllerRegistrar>>, TError,{pacienteId: string;data: RegistrarPesoDto}, TContext> => {

const mutationKey = ['pesosControllerRegistrar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pesosControllerRegistrar>>, {pacienteId: string;data: RegistrarPesoDto}> = (props) => {
          const {pacienteId,data} = props ?? {};

          return  pesosControllerRegistrar(pacienteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PesosControllerRegistrarMutationResult = NonNullable<Awaited<ReturnType<typeof pesosControllerRegistrar>>>
    export type PesosControllerRegistrarMutationBody = RegistrarPesoDto
    export type PesosControllerRegistrarMutationError = ErroResponse

    /**
 * @summary Registra uma aferição e sincroniza o `pesoKg` do cadastro na MESMA transação. O cache é o peso de MAIOR `aferidoEm`, não o que acabou de entrar: lançar uma pesagem antiga não rebaixa o peso atual. `aferidoEm` omitido = hoje.
 */
export const usePesosControllerRegistrar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pesosControllerRegistrar>>, TError,{pacienteId: string;data: RegistrarPesoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pesosControllerRegistrar>>,
        TError,
        {pacienteId: string;data: RegistrarPesoDto},
        TContext
      > => {
      return useMutation(getPesosControllerRegistrarMutationOptions(options), queryClient);
    }
    export const getPesosControllerExcluirUrl = (pacienteId: string,
    id: string,) => {




  return `/v1/pacientes/${pacienteId}/pesos/${id}`
}

/**
 * @summary Apaga a aferição e recalcula o cache pela mesma regra. Sem nenhuma aferição restante, o `pesoKg` do cadastro vira `null` — "peso desconhecido" não é "0 kg".
 */
export const pesosControllerExcluir = async (pacienteId: string,
    id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getPesosControllerExcluirUrl(pacienteId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getPesosControllerExcluirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pesosControllerExcluir>>, TError,{pacienteId: string;id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof pesosControllerExcluir>>, TError,{pacienteId: string;id: string}, TContext> => {

const mutationKey = ['pesosControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pesosControllerExcluir>>, {pacienteId: string;id: string}> = (props) => {
          const {pacienteId,id} = props ?? {};

          return  pesosControllerExcluir(pacienteId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PesosControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof pesosControllerExcluir>>>

    export type PesosControllerExcluirMutationError = ErroResponse

    /**
 * @summary Apaga a aferição e recalcula o cache pela mesma regra. Sem nenhuma aferição restante, o `pesoKg` do cadastro vira `null` — "peso desconhecido" não é "0 kg".
 */
export const usePesosControllerExcluir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pesosControllerExcluir>>, TError,{pacienteId: string;id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pesosControllerExcluir>>,
        TError,
        {pacienteId: string;id: string},
        TContext
      > => {
      return useMutation(getPesosControllerExcluirMutationOptions(options), queryClient);
    }
